// Note: There is an unresolved issue in chapter6, scene 'rebuildingHerself', beat 'focusCareer'
// that needs to be addressed separately. It's missing a transition property (next, goToChapter, or goToGameOver).

export default {
  scenes: {
    firstMeeting: {
      beats: {
        arrivalInBali: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showNarration',
              text: 'Reina arrives in Bali, her suitcase heavy and her mind buzzing with anticipation. This project is a rare opportunity, and she\'s eager to make an impression.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina introduce herself?',
              choices: [
                {
                  text: 'Confident & Outgoing',
                  next: {
                    scene: 'firstMeeting',
                    beat: 'confidentIntroduction'
                  }
                },
                {
                  text: 'Reserved but Friendly',
                  next: {
                    scene: 'firstMeeting',
                    beat: 'reservedIntroduction'
                  }
                }
              ]
            }
          ]
        },
        confidentIntroduction: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'Hi, I\'m Reina! Looking forward to working with you all.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'You sound way too enthusiastic for someone about to work.'
            }
          ],
          next: {
            scene: 'firstMeeting',
            beat: 'teamIntroductions'
          }
        },
        reservedIntroduction: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Hey, I\'m Reina. Excited to be here.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'You always this quiet, or just scoping us out?'
            }
          ],
          next: {
            scene: 'firstMeeting',
            beat: 'teamIntroductions'
          }
        },
        teamIntroductions: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliCafe'
            },
            {
              type: 'showNarration',
              text: 'The project team meets at a beachfront café, exchanging introductions over coconut drinks and warm sea air. Reina takes in the easy camaraderie around her.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'So, what exactly do you do here?'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'I make things work. And occasionally, I break them first.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina react?',
              choices: [
                {
                  text: 'Play Along',
                  next: {
                    scene: 'firstImpressions',
                    beat: 'playAlong'
                  }
                },
                {
                  text: 'Keep It Professional',
                  next: {
                    scene: 'firstImpressions',
                    beat: 'keepProfessional'
                  }
                }
              ]
            }
          ]
        }
      }
    },
    firstImpressions: {
      beats: {
        playAlong: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'Sounds efficient. Just make sure I don\'t have to clean up your mess.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'No promises.'
            }
          ],
          next: {
            scene: 'firstImpressions',
            beat: 'workSession'
          }
        },
        keepProfessional: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Well, let\'s hope we don\'t have to break too many things.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'Where\'s the fun in that?'
            }
          ],
          next: {
            scene: 'firstImpressions',
            beat: 'workSession'
          }
        },
        workSession: {
          events: [
            {
              type: 'showNarration',
              text: 'Reina and Eric are unexpectedly paired together. Their working styles couldn\'t be more different—he\'s improvisational, she\'s methodical.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina handle their differences?',
              choices: [
                {
                  text: 'Assert Her Approach',
                  next: {
                    scene: 'firstImpressions',
                    beat: 'assertApproach'
                  }
                },
                {
                  text: 'Go With the Flow',
                  next: {
                    scene: 'firstImpressions',
                    beat: 'goWithFlow'
                  }
                }
              ]
            }
          ]
        },
        assertApproach: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'angry',
              text: 'We need a structured plan before jumping in.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'Plans kill creativity. Let\'s just try things.'
            }
          ],
          next: {
            scene: 'firstImpressions',
            beat: 'learningToAdapt'
          }
        },
        goWithFlow: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Fine. But if this blows up, I\'m blaming you.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'Noted.'
            }
          ],
          next: {
            scene: 'firstImpressions',
            beat: 'learningToAdapt'
          }
        },
        learningToAdapt: {
          events: [
            {
              type: 'showNarration',
              text: 'By the end of the session, Reina realizes Eric isn\'t careless—he\'s just different. And sometimes, different works.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe being a little flexible wouldn\'t hurt.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'And maybe a little planning won\'t kill me.'
            }
          ],
          next: {
            scene: 'conversationsAtSunset',
            beat: 'teamBreaksAway'
          }
        }
      }
    },
    conversationsAtSunset: {
      beats: {
        teamBreaksAway: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showEffect',
              effect: 'overlay',
              overlayType: 'nightOverlay',
              opacity: 0.3
            },
            {
              type: 'showNarration',
              text: 'After a long day, the group walks along the beach. Conversations flow freely, and Reina ends up next to Eric.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'What does Reina ask him?',
              choices: [
                {
                  text: 'Personal Interests',
                  next: {
                    scene: 'conversationsAtSunset',
                    beat: 'personalInterests'
                  }
                },
                {
                  text: 'Travel & Adventure',
                  next: {
                    scene: 'conversationsAtSunset',
                    beat: 'travelAdventure'
                  }
                }
              ]
            }
          ]
        },
        personalInterests: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Outside of work, what\'s your thing? Hobbies?'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'A little bit of everything. But mostly, I just like learning new things.'
            }
          ],
          next: {
            scene: 'conversationsAtSunset',
            beat: 'findingCommonGround'
          }
        },
        travelAdventure: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'Have you been to a lot of places?'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'Enough to know every place has something special—if you know where to look.'
            }
          ],
          next: {
            scene: 'conversationsAtSunset',
            beat: 'findingCommonGround'
          }
        },
        findingCommonGround: {
          events: [
            {
              type: 'showNarration',
              text: 'The conversation flows, shifting from travel to books, to food, to random life experiences. Their differences don\'t seem to matter anymore.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'I can\'t believe you actually ate a fried tarantula.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'Would do it again. If you ever visit Cambodia, you have to try it.'
            },
            {
              type: 'hideEffect',
              effect: 'overlay',
              overlayType: 'nightOverlay'
            }
          ],
          next: {
            scene: 'lateNightTalks',
            beat: 'quietMoment'
          }
        }
      }
    },
    lateNightTalks: {
      beats: {
        quietMoment: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showEffect',
              effect: 'overlay',
              overlayType: 'nightOverlay',
              opacity: 0.7
            },
            {
              type: 'showNarration',
              text: 'Later that night, Reina finds Eric sitting outside by the beach, watching the waves.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina approach?',
              choices: [
                {
                  text: 'Join Him Silently',
                  next: {
                    scene: 'lateNightTalks',
                    beat: 'joinSilently'
                  }
                },
                {
                  text: 'Start a Conversation',
                  next: {
                    scene: 'lateNightTalks',
                    beat: 'startConversation'
                  }
                }
              ]
            }
          ]
        },
        joinSilently: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'It\'s peaceful out here.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'Sometimes silence is the best company.'
            }
          ],
          next: {
            scene: 'lateNightTalks',
            beat: 'unspokenUnderstanding'
          }
        },
        startConversation: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'No late-night experiments to run?'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: 'Not tonight. Just watching the waves.'
            }
          ],
          next: {
            scene: 'lateNightTalks',
            beat: 'unspokenUnderstanding'
          }
        },
        unspokenUnderstanding: {
          events: [
            {
              type: 'showNarration',
              text: 'There\'s no pressure to talk. No expectations. Just the quiet pull of the ocean and the comfort of knowing someone is there.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Do you ever feel like time moves differently in places like this?'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'thinking',
              text: 'Yeah. Like you could stay forever, and nothing would change.'
            },
            {
              type: 'hideEffect',
              effect: 'overlay',
              overlayType: 'nightOverlay'
            }
          ],
          goToChapter: {
            chapter: 'chapter2'
          }
        }
      }
    }
  }
}
